import Vshop from './images/vshop.png';
import Movie from './images/movie.png';
import Weather from './images/weather.png';
import PlayDogo from './images/playdogo.png';
import News from './images/news.png';
import Analysis from './images/analysis.png';
import Emmanuel from './images/emmanuel.jpg';
import Oluwaseun from './images/oluwaseun.jpg';
import Taskswift from './images/Taskswift.png';
import FarmSwift from './images/FarmS.png';
import Coalition from './images/Coalition.png';
import Darads from './images/Darads.png';
import OutfitLibrary from './images/Outfitlibrary.png';
import MedixDeck from './images/Medixdeck.png';
import HHG from './images/HHG.png';


export const works = [
  {
    image:HHG,
    name:'Hebron Heights and Gardens',
    description:'Hebron Heights and Gardens is an e-commerce management platform where I contributed to the frontend development of the admin dashboard. I built responsive interfaces for managing products, categories, users, orders, consultations, and notifications using Next.js, TypeScript, React, MUI, and TanStack Query, while integrating REST APIs and implementing reusable data-driven components.',
    resouces: ['Next.js', 'React', 'TypeScript', 'Material UI', 'TanStack Query', 'REST APIs', 'Axios', 'Git', 'Responsive Design', 'Admin Dashboards'],
    github:'https://github.com/vickova/hebron-heights',
    livesite:'https://hebron-heights.vercel.app/',
    type:'External'
},
  {
    image:MedixDeck,
    name:'MedixDeck',
    description:'MedixDeck is a healthcare technology platform where I worked as a Frontend Engineer, building and improving responsive web applications using ReactJS and TypeScript. I developed reusable UI components, integrated REST APIs, implemented data-driven dashboards and management interfaces, and used TanStack Query for server-state management. I also worked on authentication, role-based access, routing, and API integration while collaborating with backend developers to deliver reliable application features.',
    resouces: ['React', 'TypeScript', 'TanStack Query', 'REST APIs', 'JavaScript', 'HTML/CSS', 'Git', 'Responsive Design', 'Authentication', 'Role-Based Access', 'Data Tables'],
    github:'https://github.com/vickova',
    livesite:'https://out-fit-library.vercel.app/',
    type:'Personal'
},
  {
    image:OutfitLibrary,
    name:'OutfitLibrary',
    description:'A web application for managing and sharing outfit ideas. Users can create and organize their outfit collections, share them with friends, and get inspiration from others.',
    resouces: ['Reactjs', 'Nodejs', 'Express', 'Vercel'],
    github:'https://github.com/vickova/OutFitLibrary.git',
    livesite:'https://test.medixdeck.com/',
    type:'Personal'
},
  {
    image:FarmSwift,
    name:'FarmSwift',
    description:'A web application that makes it easy for farmers to connect with their customers',
    resouces: ['Reactjs', 'Nodejs', 'Express', 'Vercel'],
    github:'https://github.com/vickova/FarmSwift',
    livesite:'https://farm-swift.vercel.app/',
    type:'Personal'
},
{
  image:Darads,
  name:'Darads',
  description:'An e-commerce web application where user can purchase gifts for family and friend',
  resouces: ['Reactjs', '.Net', 'Vercel'],
  github:'',
  livesite:'',
  type:'Team work'
},
  {
    image:Coalition,
    name:'TaskSwift',
    description:'A project I worked on for the final stage of an interview',
    resouces: ['Reactjs', 'Nodejs', 'Express', 'Vercel'],
    github:'',
    livesite:'',
    type:'Personal'
},
    {
        image:Taskswift,
        name:'TaskSwift',
        description:'A TodoList web application that helps users organize their tasks into categories. This web applicationallows user perform CRUD operations like delete tasks, create tasks, update tasks, create category, delete category, etc.',
        resouces: ['Reactjs', 'Nodejs', 'Express', 'Vercel', 'React-toastify'],
        github:'https://github.com/vickova/TodoList-App',
        livesite:'https://todo-list-app-vickova.vercel.app/',
        type:'Personal'
    },
    {
        image:Vshop,
        name:'VShop E-commerce',
        description:'An e-commerce website that was built to learn about redux. Vshop has functionalities like add to cart, delete from cart. It has sections like furniture section, jwelries section,etc. All of the products were hand coded as no Api was consumed',
        resouces: ['Reactjs', 'Redux', 'Styled Components', 'Tailwind css', 'Vercel', ],
        github:'https://github.com/vickova/vshop_ecommerce',
        livesite:'https://vshop-ecommerce.vercel.app/',
        type:'Personal'

    },
    {
        image:Analysis,
        name:'Covid19 Analysis for Jaala',
        description: 'An analysis of the rate of covid 19 in different countries. With this project I was able to flex my knowledge on Matplotlib, Numpy and other data analysis libraries in Python. ',
        resouces: ['Python:', ' Numpy,', ' Pandas,', ' Matplotlib' ],
        github:'https://github.com/vickova',
        livesite:'https://perfect-movies.netlify.app/',
        type:'Client'
    },
    {
        image:Movie,
        name:'MovieHub',
        description: 'MovieHub is a movie website that was built using the TMDB Api. This project has deatures like the light mode and dark mode features, it also shows the most popular and the most trending movies in the world. You can also get to watch the trailer of these movies on Youtube through this website',
        resouces: ['Reactjs', 'Redux', 'Styled Components', 'Tailwind css', 'Vercel', ],
        github:'https://github.com/vickova/Movie-perfected',
        livesite:'https://perfect-movies.netlify.app/',
        type:'Personal'
    },
    {
        image:Weather,
        name:'Weather App',
        description: 'For this weather app project, I consumed an Api called the weather Api and with this I was able to create a search section, a forecast section and every other section a weather app should have. This website also has the darkmode and lightmode features.',
        resouces: ['Reactjs', 'Redux', 'Styled Components', 'Tailwind css', 'Vercel', ],
        github:'https://github.com/vickova/Weather_Site',
        livesite:'https://weather-site-pied.vercel.app/',
        type:'Personal'
    },
    {
        image:PlayDogo,
        name:'PlayDogo',
        description: 'Playdogo is a kids learning website that was built to increase my knowledge of react. THis website helped me fles my knowledge on framer motion.',
        resouces: ['Reactjs', 'Redux', 'Styled Components', 'Tailwind css', 'Vercel', ],
        github:'https://github.com/vickova',
        livesite:'https://vic-kidsplay.netlify.app/',
        type:'Personal'
    },
    {
        image:News,
        name:'News',
        description: 'The News Website is a website that displays the latest news, you can also search for news based on the keyword you type. AN Api was consumed for this project',
        resouces: ['Reactjs', 'Redux', 'Styled Components', 'Tailwind css', 'Vercel', ],
        github:'https://github.com/vickova/News',
        livesite:'https://newsbegins.vercel.app/',
        type:'Personal'
    }
];

export const Projects = [
    {
      name:'Decagon replicate',
      description: 'A replicate of the popular decagon website. This website was built using react to improve my react skills.',
      resouces: ['Reactjs',  'Styled Components' ],
      github:'https://github.com/vickova/',
      livesite:'https://tony-vic-template.netlify.app',
    },
    {
      name:'Sunny Side',
      description: 'A frontendmentor.io challenge. This website was built using just Html, Css and Javascript to improve my skills.',
      resouces: ['Reactjs',  'Styled Components' ],
      github:'https://github.com/vickova/',
      livesite:'https://sunnyside-v.netlify.app',
    },
    {
      name:'Techies Award',
      description: 'A replicate of the popular Techies Award website. A website that was built using react to improve my react skills. It is an ineresting single page website',
      resouces: ['Reactjs',  'Styled Components' ],
      github:'https://github.com/vickova/',
      livesite:'https://techie-awards.netlify.app',
    },
    {
      name:'Loop Studio',
      description: 'A frontendmentor.io challenge. This website was built using just Html, Css and Javascript to improve my skills.',
      resouces: ['Reactjs',  'Styled Components' ],
      github:'https://github.com/vickova/',
      livesite:'https://loopstudios-v.netlify.app/',
    },
    {
      name:'Test Dashboard',
      description: 'A dashboard website that was built using reactjs to improve my skills. It is an ineresting single page website',
      resouces: ['Reactjs',  'Styled Components' ],
      github:'https://github.com/vickova/',
      livesite:'https://vicky-react-test1.netlify.app',
    },
    {
      name:'Top Intern',
      description: 'A website that was built using react to improve my react skills. It is an ineresting single page website',
      resouces: ['Reactjs',  'Styled Components' ],
      github:'https://github.com/vickova/',
      livesite:'https://topintern-first.netlify.app/',
    },
  ];
  export const testimonial = [
    {
      name:'Emmanuel - Eunit ',
      title: 'Software developer | Technical writer',
      image: Emmanuel,
      words:"Victoria writes clean codes and logic, it's a delight walking with you always",
    },
    {
      name:'Oluwaseun O. OWONIFARI',
      title:'Genetics | Research | Writing',
      image: Oluwaseun,
      words:'The VO! Everyone needs you on their team. Overall best in intentionality and consistency',
    }
  ]